// extracted by mini-css-extract-plugin
export default {"switch":"switch_switch__CQR6c","checked":"switch_checked__BGc+X","disabled":"switch_disabled__OOkyJ","thumb":"switch_thumb__jPcTz"};